import "./ProjectCard.scss";

import { Project, ProjectCategory } from "../../../../config/projects";

const CATEGORY_CLASS: Record<ProjectCategory, string> = {
  web3: "catWeb3",
  frontend: "catFrontend",
  fullstack: "catFullstack",
  mobile: "catMobile",
  desktop: "catDesktop",
  game: "catGame",
};

const CATEGORY_LABEL: Record<ProjectCategory, string> = {
  web3: "Web3",
  frontend: "Frontend",
  fullstack: "Full-Stack",
  mobile: "Mobile",
  desktop: "Desktop",
  game: "Game",
};

const STATUS_CLASS: Record<string, string> = {
  active: "statusActive",
  done: "statusDone",
  wip: "statusActive",
};

const ProjectCard = ({
  project,
  displayNumber,
  className,
}: {
  project: Project;
  displayNumber?: string;
  className?: string;
}) => {
  return (
    <div
      className={`projectCard${className ? ` ${className}` : ""}`}
      data-n={displayNumber ?? project.number}
    >
      <div className="projectMeta">
        <span className={`projectCat ${CATEGORY_CLASS[project.category]}`}>
          {CATEGORY_LABEL[project.category]}
        </span>
        <span className={`projectStatus ${STATUS_CLASS[project.status]}`}>
          {project.statusLabel}
        </span>
      </div>
      <div className="projectTitle">{project.title}</div>
      <p className="projectDesc">{project.description}</p>
      <div className="projectTech">
        {project.tags.map((tag) => (
          <span key={tag} className="projectTag">
            {tag}
          </span>
        ))}
      </div>
      {project.url && (
        <a
          href={project.url}
          className="projectLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          {project.urlLabel} ↗
        </a>
      )}
    </div>
  );
};

export default ProjectCard;
